import { SliderSettings } from "../../../../../Shared/components/CardLayout/SliderSettings";
import { clone } from "../../../../../Shared/utils/clone";
/**
 * Builds and returns the props object for a recipe card component based on provided configuration and state.
 * Merges handler props and sets up event handlers and display settings for the card.
 *
 * @param BuildCardPropsArgs
 * @returns ItemCardProps
 */
export const buildRecipeCardProps = ({ moduleConfig, pmwr, recipe, recipeHandlerProps_One, recipeImageBaseUrl, setAssignmentId, setIsAddDisabled, setMeals, setQuantity, store, }) => {
    var _a;
    const recipeHandlerProps_Two = {
        isAddDisabled: recipe.cardProps.isAddDisabled,
        programMealId: (_a = pmwr.meal) === null || _a === void 0 ? void 0 : _a.ProgramMealId,
        recipe: recipe.recipe,
        recipeId: recipe.recipe.RecipeId,
        setAssignmentId,
        setIsAddDisabled,
        setMeals,
        setQuantity,
        storeCartMeals: store.cart.meals,
    };
    const recipeHandlerProps_Three = Object.assign(Object.assign({}, recipeHandlerProps_One), recipeHandlerProps_Two);
    const propsReturn = Object.assign(Object.assign({}, recipe.cardProps), { availableQuantity: recipe.recipe.AvailableQuantity, imageBaseUrl: recipeImageBaseUrl, onCustomizeClick: (assignmentId) => {
            setAssignmentId(assignmentId);
            setMeals(clone(store.cart.meals));
            setIsAddDisabled(recipe.cardProps.isAddDisabled);
        }, sliderSettings: SliderSettings(moduleConfig.ScreenLG, moduleConfig.ScreenMD, false, false), recipeAutoSelection: moduleConfig.RecipeAutoSelection, dislikeIds: store.cart.omissions.map((o) => o.dislikeId), alwaysPromptCustomizeModal: store.model.GeneralSettings.AlwaysPromptCustomizeMealModal, recipeHandlerProps_Three });
    return propsReturn;
};
